<!--
 * @Description: 产品使用情况
 * @Author: ChangWenBo (649160016@qq.com)
 * @Date: 2021-04-06 13:40:37
 * @LastEditors: ChangWenBo (649160016@qq.com)
 * @LastEditTime: 2021-04-08 14:23:36
 -->
<template>
  <div class="pruductUse">
    <div class="dateTabs">
      <span
        :class="[`dateItem ${dateActive === index ? 'active' : ''}`]"
        v-for="(item, index) in dateTabs"
        :key="index"
        @click="selectDate(index)">{{item.label}}</span>
    </div>
    <div class="titleHeader">
      <img src="/static/img/layout/arrow-orange.png" alt="">
      <span class="titleName">产品使用情况</span>
    </div>
    <div class="content">
      <div class="item" v-for="(item, index) in progressConfig" :key="index">
        <span class="title">{{item.name}}</span>
        <dv-percent-pond class="progress" :config="item.config" style="width:40%;height:20px;" />
        <span class="progressValue">{{item.config.value}}%</span>
        <span :class="activeStatusClass(item.config.value)">{{activeStatus(item.config.value)}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { timestampFormat } from '@/utils/timestampFormat'
export default {
  name: 'pruductUse',
  components: {
  },
  data () {
    return {
      dateActive: 0,
      dateTabs: [
        {
          label: '今日',
          value: 'day',
        },
        {
          label: '本周',
          value: 'week',
        },
        {
          label: '本月',
          value: 'month',
        },
      ],
      progressConfig: [],
      startDate: timestampFormat('YYYY-mm-dd', new Date()),
      endDate: timestampFormat('YYYY-mm-dd', new Date()),
    }
  },
  methods: {
    /**
     * @description                   产品使用情况动态class
     * @param     {Number}            活跃度值
     * @return {string}               class名
     */
    activeStatusClass (value) {
      if (value <= 20) {
        return 'free'
      } else if (value > 20 && value < 60) {
        return 'commonly'
      } else if (value >= 60) {
        return 'normal'
      }
    },
    /**
     * @description                   产品使用情况状态
     * @param     {Number}            活跃度值
     * @return {string}               状态
     */
    activeStatus (value) {
      if (value <= 20) {
        return '闲置'
      } else if (value > 20 && value < 60) {
        return '一般'
      } else if (value >= 60) {
        return '正常'
      }
    },
    /**
     * @description                   日期切换
     * @param     {Number}          当前选择索引
     * @return {undefied}             无返回值
     */
    selectDate (index) {
      this.dateActive = index
      if (index === 0) {
        this.startDate = timestampFormat('YYYY-mm-dd', new Date())
        this.endDate = timestampFormat('YYYY-mm-dd', new Date())
      } else if (index === 1) {
        this.startDate = timestampFormat('YYYY-mm-dd', new Date(new Date().getTime() - (new Date().getDay() - 1) * 86400000))
        this.endDate = timestampFormat('YYYY-mm-dd', new Date())
      } else if (index === 2) {
        this.startDate = timestampFormat('YYYY-mm-dd', new Date(new Date().getTime() - (new Date().getDate() - 1) * 86400000))
        this.endDate = timestampFormat('YYYY-mm-dd', new Date())
      }
      this.getProductUseData()
    },
    /**
     * @description                   获取产品使用情况数据
     * @return {undefied}             无返回值
     */
    getProductUseData () {
      this.$http.get('/rest/screen/home/listProductUsage', {
        startDate: this.startDate,
        endDate: this.endDate,
      })
        .then(res => {
          if (res.code === 0) {
            let data = res.data
            data.map(k => {
              k.config = {
                value: k.usage,
                colors: ['#e04516', '#50f2b7'],
                borderWidth: 1,
              }
            })
            this.progressConfig = data
          } else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
        })
    },
  },
  created () {
    this.getProductUseData()
  },
}
</script>

<style lang="less" scoped>
  .pruductUse {
    width: 100%;
    height: 90%;
    position: relative;
    .dateTabs {
      position: absolute;
      right: 0;
      top: 0;
      width: 120px;
      height: 30px;
      border: 1px solid #05dbe3;
      border-radius: 4px;
      .dateItem {
        text-align: center;
        font-size: 16px;
        color: #fff;
        width: 33.33%;
        height: 100%;
        display: inline-flex;
        align-items: center;
        justify-content: space-around;
        cursor: pointer;
      }
      .active {
        background: #04b8bf;
      }
    }
    .titleHeader {
      width: 100%;
      height: 40px;
      background: url('/static/img/layout/titleHeaderBg.png');
      background-size: 100% 100%;
      >img {
        height: 100%;
        margin-right: 20px;
        vertical-align: middle;
      }
      .titleName {
        font-size: 20px;
        vertical-align: middle;
        display: inline-block;
        color: #05dbe3;
        height: 40px;
        line-height: 40px;
      }
    }
    .content {
      width: 100%;
      height: calc(100% - 40px);
      .item {
        width: 50%;
        height: 33%;
        display: inline-flex;
        justify-content: space-around;
        align-items: center;
        .title {
          display: inline-block;
          width: calc(35% - 10px);
          padding-right: 10px;
          font-size: 18px;
          color: #fff;
          text-align: right;
          vertical-align: middle;
        }
        .progress {
          display: inline-block;
          vertical-align: middle;
        }
        /deep/.dv-percent-pond text {
          display: none !important;
        }
        .progressValue {
          vertical-align: middle;
          font-size: 18px;
          color: #fff;
          width: 10%;
          text-align: center;
        }
        .free {
          vertical-align: middle;
          border: 1px solid #da0000;
          color: #da0000;
          font-size: 18px;
          border-radius: 4px;
          padding: 2px;
        }
        .commonly {
          vertical-align: middle;
          border: 1px solid #ff7123;
          color: #ff7123;
          font-size: 18px;
          border-radius: 4px;
          padding: 2px;
        }
        .normal {
          vertical-align: middle;
          border: 1px solid #00ffee;
          color: #00ffee;
          font-size: 18px;
          border-radius: 4px;
          padding: 2px;
        }
      }
    }
  }
</style>
